// Engine output for the active case (copied from the hybrid app; disOS runs the engine with the published tables).
import { createContext, useContext, useMemo } from 'react';
import type { Case, CaseResult } from '@divorceos/schema';
import { compute } from '../dis/model';

export interface EngineOutput {
  result: CaseResult | null;
  /** Set when the engine threw. */
  engineError: string | null;
  labels: [string, string];
}

const EMPTY: EngineOutput = { result: null, engineError: null, labels: ['Party A', 'Party B'] };

export const ResultContext = createContext<EngineOutput>(EMPTY);
export const useResult = (): EngineOutput => useContext(ResultContext);

export { useDebounced } from '../dis/useDebounced';

/** Runs the engine on `data`; engine errors become `engineError`. `labels` are disOS's chosen party labels. */
export function useEngine(data: Case, labels: [string, string]): EngineOutput {
  return useMemo<EngineOutput>(() => {
    try {
      return { result: compute(data), engineError: null, labels };
    } catch (e) {
      return { result: null, engineError: e instanceof Error ? e.message : String(e), labels };
    }
  }, [data, labels]);
}
